import React from 'react';

import { Link } from 'gatsby';
import styled from '@emotion/styled';
import { mq, green01, green02, fastDurationTime, slowDurationTime} from '../../_style';

import Text from '../atoms/text';
import Image from '../atoms/image';

const Container = styled.div`
  height: inherit;
`
const Inner = styled(Link)`
  height: inherit;
  display: block;
  padding-bottom: 40px;
  position: relative;
  border-bottom: solid 1px ${green02};
  box-sizing: border-box;
  &::after {
    background-color: ${green01};
    content: "";
    display: block;
    width: 0%;
    height: 1px;
    position: absolute;
    bottom: -1px;
    right: 0;
    left: auto;
    transition: width ${fastDurationTime} ease;
  }
  &:hover::after {
    width: 100%;
    right: auto;
    left: 0;
  }
`
const Img = styled.div`
  margin-bottom: 20px;
  border-radius: 3px;
  overflow: hidden;
  > div {
    backface-visibility: hidden;
    transition: transform ${slowDurationTime} ease-out;
    a:hover & {
      transform: scale(1.04);
    }
  }
`
const TextBlock = styled.div`
  p {
    transition: color ${fastDurationTime} ease;
  }
  a:hover & p {
    color: ${green01};
  }
`
const Arrow = styled.div`
  width: 18px;
  height: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: solid 1px ${green01};
  border-radius: 50%;
  position: absolute;
  right: 0;
  bottom: 15px;
  transition: background-color ${fastDurationTime} ease;
  svg {
    fill: ${green01};
    transform: translateX(0.5px);
    transition: fill ${fastDurationTime} ease;
  }
  a:hover & {
    background-color: ${green01};
    svg {
      fill: #fff;
    }
  }
`

export default class ColumnItem extends React.Component {
  render() {
    return(
      <Container>
        <Inner to={this.props.to}>
          <Img>
            <Image filename={this.props.thumb} alt=""></Image>
          </Img>
          <TextBlock>
            <Text lead>{this.props.children}</Text>
          </TextBlock>
          <Arrow>
            <svg xmlns="http://www.w3.org/2000/svg" width="4.04" height="7.65" viewBox="0 0 4.04 7.65"><path d="M.76 7.65L0 7l2.72-3.17L0 .65.76 0l3.28 3.83L.76 7.65z"/></svg>
          </Arrow>
        </Inner>
      </Container>
    );
  }
}
